import { getShortUrl } from 'PrivateApis';

export const setShortUrlsUTM = (campaignValue?: string) => new URLSearchParams({
  mw_medium: 'seller_webapp',
  mw_source: 'premium_form',
  ...(campaignValue ? { mw_campaign: campaignValue } : {}),
});

export const postShortUrl = async (
  id: number,
  body: { field: string; path: string },
  abortController: AbortController,
) => {
  const captureError = (err: Error) => {
    window?.Sentry?.captureException?.(err, {
      extra: {
        photoAppUrlBody: body,
      },
      level: 'error',
      tags: {
        fetch: 'Photo App URL',
      },
    });
  };

  try {
    const result = await getShortUrl(id, body, abortController);

    const { url } = result || {};

    if (!url || typeof url !== 'string' || !url.match(/^https?:\/\/[a-zA-Z]/)) {
      captureError(new Error(JSON.stringify(url)));
      return null;
    }

    return url;
  } catch (err) {
    captureError(new Error(err as string));
  }

  return null;
};

type ShortUrlType = {
  abortController: AbortController;
  id: number;
  loginToken?: string;
  photosQuery: string;
  photosUrl?: string;
  vehicleVrm: string;
};

export const setShortUrl = async ({
  abortController, id, loginToken, photosQuery, photosUrl, vehicleVrm,
}: ShortUrlType) => {
  const params = photosQuery ? `?${photosQuery}` : '';
  const photosPath = `${photosUrl}/${vehicleVrm}${params}`;

  const photosAppUrl = await postShortUrl(id, {
    field: 'Photo app',
    path: photosPath,
  }, abortController);

  const token = loginToken ? `token=${loginToken}` : '';

  return photosAppUrl ?? `${photosPath}${params ? '&' : '?'}${token}`;
};

export const compareTimeDifference = (start: number, end: number, diff: number) => {
  const differenceInMinutes = (start - end) / (1000 * 60);

  return differenceInMinutes >= diff;
};

export const RESEND_SMS_TIME = 15;
